
import { ApiService } from '..';

export const KamService = {
    get() {
        return ApiService.get('kams');
    }
};